import { Message } from "primereact/message";
import type { AvisoStatusCondicoesViewModel } from "./types-aviso-status-condicoes";

/** Aviso do estado da verificação de condições: criar só é possível com ela concluída (HU 2549). */
export function AvisoStatusCondicoesView({ mensagem }: AvisoStatusCondicoesViewModel) {
  if (!mensagem) return null;

  return (
    <Message
      severity="warn"
      role="status"
      data-testid="revisao-status-condicoes"
      className="p-message-block"
      text={mensagem}
    />
  );
}
